webpackJsonp([11,50,132,133,134,229,286,287],{

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1064);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(900)("4a844131", content, true);

/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(899)(true);
// imports


// module
exports.push([module.i, "\n.tag[data-v-19806782] {\n        cursor: pointer;\n}\n", "", {"version":3,"sources":["/root/Awesome-UI/buefy/docs/pages/components/dropdown/examples/ExSimple.vue"],"names":[],"mappings":";AACA;QACQ,gBAAgB;CACvB","file":"ExSimple.vue","sourcesContent":["\n.tag[data-v-19806782] {\n        cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1065:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-dropdown', {
    attrs: {
      "aria-role": "list"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Click me!")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Something else")])], 1), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "hoverable": "",
      "aria-role": "list"
    }
  }, [_c('button', {
    staticClass: "button is-info",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Hover me!")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Something else")])], 1), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "disabled": "",
      "aria-role": "list"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Disabled")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Something else")])], 1), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "aria-role": "list"
    }
  }, [_c('p', {
    staticClass: "tag is-success",
    attrs: {
      "slot": "trigger",
      "role": "button"
    },
    slot: "trigger"
  }, [_vm._v("\n                Custom trigger\n            ")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Something else")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1066:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-item"
  }, [_c('b-icon', {
    attrs: {
      "pack": "fab",
      "icon": "github"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "navbar-item"
  }, [_c('b-icon', {
    attrs: {
      "pack": "fab",
      "icon": "twitter"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('b-dropdown', {
    attrs: {
      "position": "is-bottom-left",
      "aria-role": "menu",
      "trap-focus": ""
    }
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "slot": "trigger",
      "role": "button"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Login")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "menu-item",
      "focusable": false,
      "custom": "",
      "paddingless": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "placeholder": "Your email",
      "required": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password",
      "password-reveal": "",
      "placeholder": "Your password",
      "required": ""
    }
  })], 1), _vm._v(" "), _c('b-checkbox', [_vm._v("Remember me")])], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Login")])])])])])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-item"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/buefy-logo.png",
      "alt": "Buefy"
    }
  })])
}]}

/***/ }),

/***/ 1067:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            navigation: 'home'
        };
    }
});

/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-item"
  }, [_c('b-icon', {
    attrs: {
      "pack": "fab",
      "icon": "github"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "navbar-item"
  }, [_c('b-icon', {
    attrs: {
      "pack": "fab",
      "icon": "twitter"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('b-dropdown', {
    attrs: {
      "position": "is-bottom-left",
      "aria-role": "menu"
    },
    model: {
      value: (_vm.navigation),
      callback: function($$v) {
        _vm.navigation = $$v
      },
      expression: "navigation"
    }
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "slot": "trigger",
      "role": "button"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Menu")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "custom": "",
      "aria-role": "menuitem"
    }
  }, [_vm._v("\n                        Logged as "), _c('b', [_vm._v("Rafael Beraldo")])]), _vm._v(" "), _c('hr', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "has-link": "",
      "aria-role": "menuitem"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://google.com",
      "target": "_blank"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v("\n                            Google (link)\n                        ")], 1)]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "home",
      "aria-role": "menuitem"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "home"
    }
  }), _vm._v("\n                        Home\n                    ")], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "products",
      "aria-role": "menuitem"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "cart"
    }
  }), _vm._v("\n                        Products\n                    ")], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "blog",
      "disabled": "",
      "aria-role": "menuitem"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "book-open"
    }
  }), _vm._v("\n                        Blog\n                    ")], 1), _vm._v(" "), _c('hr', {
    staticClass: "dropdown-divider",
    attrs: {
      "aria-role": "menuitem"
    }
  }), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "settings"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "settings"
    }
  }), _vm._v("\n                        Settings\n                    ")], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "logout",
      "aria-role": "menuitem"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "logout"
    }
  }), _vm._v("\n                        Logout\n                    ")], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-item"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/buefy-logo.png",
      "alt": "Buefy"
    }
  })])
}]}

/***/ }),

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isPublic: true
        };
    }
});

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dropdown', {
    attrs: {
      "aria-role": "list"
    },
    model: {
      value: (_vm.isPublic),
      callback: function($$v) {
        _vm.isPublic = $$v
      },
      expression: "isPublic"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "slot": "trigger",
      "type": "button"
    },
    slot: "trigger"
  }, [(_vm.isPublic) ? [_c('b-icon', {
    attrs: {
      "icon": "earth"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Public")])] : [_c('b-icon', {
    attrs: {
      "icon": "account-multiple"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Friends")])], _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 2), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": true,
      "aria-role": "listitem"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('b-icon', {
    staticClass: "media-left",
    attrs: {
      "icon": "earth"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('h3', [_vm._v("Public")]), _vm._v(" "), _c('small', [_vm._v("Everyone can see")])])], 1)]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": false,
      "aria-role": "listitem"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('b-icon', {
    staticClass: "media-left",
    attrs: {
      "icon": "account-multiple"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('h3', [_vm._v("Friends")]), _vm._v(" "), _c('small', [_vm._v("Only friends can see")])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1071:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedOptions: []
        };
    }
});

/***/ }),

/***/ 1072:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("selected")]), _vm._v(": " + _vm._s(_vm.selectedOptions))]), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "multiple": "",
      "aria-role": "list"
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "slot": "trigger",
      "type": "button"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Selected (" + _vm._s(_vm.selectedOptions.length) + ")")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "option1",
      "aria-role": "listitem"
    }
  }, [_c('span', [_vm._v("Option 1")])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "option2",
      "aria-role": "listitem"
    }
  }, [_c('span', [_vm._v("Option 2")])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "option3",
      "aria-role": "listitem"
    }
  }, [_c('span', [_vm._v("Option 3")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_dropdown__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables_dropdown__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExContentPosition__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExContentPosition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__examples_ExContentPosition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExContentPosition__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExContentPosition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExContentPosition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExHasLinkDisabled__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExHasLinkDisabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__examples_ExHasLinkDisabled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExHasLinkDisabled__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExHasLinkDisabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExHasLinkDisabled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExCustomize__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExCustomize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__examples_ExCustomize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExCustomize__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExCustomize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExCustomize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExCustomizeMultiple__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExCustomizeMultiple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__examples_ExCustomizeMultiple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExCustomizeMultiple__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExCustomizeMultiple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExCustomizeMultiple__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_dropdown__["default"],
            variables: __WEBPACK_IMPORTED_MODULE_1__variables_dropdown__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default.a,
            ExContentPosition: __WEBPACK_IMPORTED_MODULE_4__examples_ExContentPosition___default.a,
            ExContentPositionCode: __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExContentPosition___default.a,
            ExHasLinkDisabled: __WEBPACK_IMPORTED_MODULE_6__examples_ExHasLinkDisabled___default.a,
            ExHasLinkDisabledCode: __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExHasLinkDisabled___default.a,
            ExCustomize: __WEBPACK_IMPORTED_MODULE_8__examples_ExCustomize___default.a,
            ExCustomizeCode: __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExCustomize___default.a,
            ExCustomizeMultiple: __WEBPACK_IMPORTED_MODULE_10__examples_ExCustomizeMultiple___default.a,
            ExCustomizeMultipleCode: __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExCustomizeMultiple___default.a
        };
    }
});

/***/ }),

/***/ 1385:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-dropdown aria-role=\"list\">\n            <button class=\"button is-primary\" slot=\"trigger\">\n                <span>Click me!</span>\n                <b-icon icon=\"menu-down\"></b-icon>\n            </button>\n\n            <b-dropdown-item aria-role=\"listitem\">Action</b-dropdown-item>\n            <b-dropdown-item aria-role=\"listitem\">Another action</b-dropdown-item>\n            <b-dropdown-item aria-role=\"listitem\">Something else</b-dropdown-item>\n        </b-dropdown>\n\n        <b-dropdown hoverable aria-role=\"list\">\n            <button class=\"button is-info\" slot=\"trigger\">\n                <span>Hover me!</span>\n                <b-icon icon=\"menu-down\"></b-icon>\n            </button>\n\n            <b-dropdown-item aria-role=\"listitem\">Action</b-dropdown-item>\n            <b-dropdown-item aria-role=\"listitem\">Another action</b-dropdown-item>\n            <b-dropdown-item aria-role=\"listitem\">Something else</b-dropdown-item>\n        </b-dropdown>\n\n        <b-dropdown disabled aria-role=\"list\">\n            <button class=\"button\" slot=\"trigger\">\n                <span>Disabled</span>\n                <b-icon icon=\"menu-down\"></b-icon>\n            </button>\n\n            <b-dropdown-item aria-role=\"listitem\">Action</b-dropdown-item>\n            <b-dropdown-item aria-role=\"listitem\">Another action</b-dropdown-item>\n            <b-dropdown-item aria-role=\"listitem\">Something else</b-dropdown-item>\n        </b-dropdown>\n\n        <b-dropdown aria-role=\"list\">\n            <p\n                class=\"tag is-success\"\n                slot=\"trigger\"\n                role=\"button\">\n                Custom trigger\n            </p>\n\n            <b-dropdown-item aria-role=\"listitem\">Action</b-dropdown-item>\n            <b-dropdown-item aria-role=\"listitem\">Another action</b-dropdown-item>\n            <b-dropdown-item aria-role=\"listitem\">Something else</b-dropdown-item>\n        </b-dropdown>\n    </section>\n</template>\n\n<style scoped>\n    .tag {\n        cursor: pointer;\n    }\n</style>\n"

/***/ }),

/***/ 1386:
/***/ (function(module, exports) {

module.exports = "<template>\n    <nav class=\"navbar\">\n        <div class=\"navbar-brand\">\n            <a class=\"navbar-item\">\n                <img src=\"/static/img/buefy-logo.png\" alt=\"Buefy\">\n            </a>\n            <a class=\"navbar-item\"><b-icon pack=\"fab\" icon=\"github\"></b-icon></a>\n            <a class=\"navbar-item\"><b-icon pack=\"fab\" icon=\"twitter\"></b-icon></a>\n        </div>\n\n        <div class=\"navbar-menu\">\n            <div class=\"navbar-end\">\n                <b-dropdown position=\"is-bottom-left\" aria-role=\"menu\" trap-focus>\n                    <a\n                        class=\"navbar-item\"\n                        slot=\"trigger\"\n                        role=\"button\">\n                        <span>Login</span>\n                        <b-icon icon=\"menu-down\"></b-icon>\n                    </a>\n\n                    <b-dropdown-item\n                        aria-role=\"menu-item\"\n                        :focusable=\"false\"\n                        custom\n                        paddingless>\n                        <form action=\"\">\n                            <div class=\"modal-card\" style=\"width:300px;\">\n                                <section class=\"modal-card-body\">\n                                    <b-field label=\"Email\">\n                                        <b-input\n                                            type=\"email\"\n                                            placeholder=\"Your email\"\n                                            required>\n                                        </b-input>\n                                    </b-field>\n\n                                    <b-field label=\"Password\">\n                                        <b-input\n                                            type=\"password\"\n                                            password-reveal\n                                            placeholder=\"Your password\"\n                                            required>\n                                        </b-input>\n                                    </b-field>\n\n                                    <b-checkbox>Remember me</b-checkbox>\n                                </section>\n                                <footer class=\"modal-card-foot\">\n                                    <button class=\"button is-primary\">Login</button>\n                                </footer>\n                            </div>\n                        </form>\n                    </b-dropdown-item>\n                </b-dropdown>\n            </div>\n        </div>\n    </nav>\n</template>\n"

/***/ }),

/***/ 1387:
/***/ (function(module, exports) {

module.exports = "<template>\n    <nav class=\"navbar\">\n        <div class=\"navbar-brand\">\n            <a class=\"navbar-item\">\n                <img src=\"/static/img/buefy-logo.png\" alt=\"Buefy\">\n            </a>\n            <a class=\"navbar-item\"><b-icon pack=\"fab\" icon=\"github\"></b-icon></a>\n            <a class=\"navbar-item\"><b-icon pack=\"fab\" icon=\"twitter\"></b-icon></a>\n        </div>\n\n        <div class=\"navbar-menu\">\n            <div class=\"navbar-end\">\n                <b-dropdown                    \n                    v-model=\"navigation\"\n                    position=\"is-bottom-left\"\n                    aria-role=\"menu\">\n                    <a\n                        class=\"navbar-item\"\n                        slot=\"trigger\"\n                        role=\"button\">\n                        <span>Menu</span>\n                        <b-icon icon=\"menu-down\"></b-icon>\n                    </a>\n\n                    <b-dropdown-item custom aria-role=\"menuitem\">\n                        Logged as <b>Rafael Beraldo</b>\n                    </b-dropdown-item>\n                    <hr class=\"dropdown-divider\">\n                    <b-dropdown-item has-link aria-role=\"menuitem\">\n                        <a href=\"https://google.com\" target=\"_blank\">\n                            <b-icon icon=\"link\"></b-icon>\n                            Google (link)\n                        </a>\n                    </b-dropdown-item>\n                    <b-dropdown-item value=\"home\" aria-role=\"menuitem\">\n                        <b-icon icon=\"home\"></b-icon>\n                        Home\n                    </b-dropdown-item>\n                    <b-dropdown-item value=\"products\" aria-role=\"menuitem\">\n                        <b-icon icon=\"cart\"></b-icon>\n                        Products\n                    </b-dropdown-item>\n                    <b-dropdown-item value=\"blog\" disabled aria-role=\"menuitem\">\n                        <b-icon icon=\"book-open\"></b-icon>\n                        Blog\n                    </b-dropdown-item>\n                    <hr class=\"dropdown-divider\" aria-role=\"menuitem\">\n                    <b-dropdown-item value=\"settings\">\n                        <b-icon icon=\"settings\"></b-icon>\n                        Settings\n                    </b-dropdown-item>\n                    <b-dropdown-item value=\"logout\" aria-role=\"menuitem\">\n                        <b-icon icon=\"logout\"></b-icon>\n                        Logout\n                    </b-dropdown-item>\n                </b-dropdown>\n            </div>\n        </div>\n    </nav>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                navigation: 'home'\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1388:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-dropdown v-model=\"isPublic\" aria-role=\"list\">\n        <button class=\"button is-primary\" type=\"button\" slot=\"trigger\">\n            <template v-if=\"isPublic\">\n                <b-icon icon=\"earth\"></b-icon>\n                <span>Public</span>\n            </template>\n            <template v-else>\n                <b-icon icon=\"account-multiple\"></b-icon>\n                <span>Friends</span>\n            </template>\n            <b-icon icon=\"menu-down\"></b-icon>\n        </button>\n\n        <b-dropdown-item :value=\"true\" aria-role=\"listitem\">\n            <div class=\"media\">\n                <b-icon class=\"media-left\" icon=\"earth\"></b-icon>\n                <div class=\"media-content\">\n                    <h3>Public</h3>\n                    <small>Everyone can see</small>\n                </div>\n            </div>\n        </b-dropdown-item>\n\n        <b-dropdown-item :value=\"false\" aria-role=\"listitem\">\n            <div class=\"media\">\n                <b-icon class=\"media-left\" icon=\"account-multiple\"></b-icon>\n                <div class=\"media-content\">\n                    <h3>Friends</h3>\n                    <small>Only friends can see</small>\n                </div>\n            </div>\n        </b-dropdown-item>\n    </b-dropdown>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                isPublic: true\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1389:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <p class=\"content\"><b>selected</b>: {{ selectedOptions }}</p>\n        <b-dropdown\n            v-model=\"selectedOptions\"\n            multiple\n            aria-role=\"list\">\n            <button class=\"button is-primary\" type=\"button\" slot=\"trigger\">\n                <span>Selected ({{ selectedOptions.length }})</span>\n                <b-icon icon=\"menu-down\"></b-icon>\n            </button>\n\n            <b-dropdown-item value=\"option1\" aria-role=\"listitem\">\n                <span>Option 1</span>\n            </b-dropdown-item>\n\n            <b-dropdown-item value=\"option2\" aria-role=\"listitem\">\n                <span>Option 2</span>\n            </b-dropdown-item>\n\n            <b-dropdown-item value=\"option3\" aria-role=\"listitem\">\n                <span>Option 3</span>\n            </b-dropdown-item>\n        </b-dropdown>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                selectedOptions: []\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1390:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }, [_c('p', [_vm._v("\n                While it appear as a modal for tablet and smartphones,\n                Dropdowns with "), _c('code', [_vm._v("hoverable")]), _vm._v(" prop won't change it's behavior to avoid any malfunction with hover.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExContentPosition,
      "code": _vm.ExContentPositionCode,
      "title": "Content and position",
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("custom")]), _vm._v(" prop to the item to add "), _c('strong', [_vm._v("any type of content")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Add the "), _c('code', [_vm._v(":focusable=\"false\"")]), _vm._v(" prop to the "), _c('code', [_vm._v("dropdown-item")]), _vm._v(" if you dont want it to be focusable.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExHasLinkDisabled,
      "code": _vm.ExHasLinkDisabledCode,
      "title": "Links within",
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("has-link")]), _vm._v(" prop to add a anchor tag / router-link, or "), _c('code', [_vm._v("disabled")]), _vm._v(" to disable an item.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomize,
      "code": _vm.ExCustomizeCode,
      "title": "Customizing with v-model"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomizeMultiple,
      "code": _vm.ExCustomizeMultipleCode,
      "title": "Multiple"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.6")])]), _vm._v(" "), _c('p', [_vm._v("Add the "), _c('code', [_vm._v("multiple")]), _vm._v(" prop to select one or more item.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    title: 'Dropdown',
    props: [{
        name: '<code>v-model</code>',
        description: 'Binding value',
        type: 'Any',
        values: '—',
        default: '<code>null</code>'
    }, {
        name: '<code>hoverable</code>',
        description: 'Dropdown will be triggered by hover instead of click',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>position</code>',
        description: 'Optional, position of the dropdown relative to the trigger',
        type: 'String',
        values: '<code>is-top-right</code>, <code>is-top-left</code>, <code>is-bottom-left</code>',
        default: 'Bottom right'
    }, {
        name: '<code>disabled</code>',
        description: 'Disables dropdown',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>animation</code>',
        description: 'Custom animation (transition name)',
        type: 'String',
        values: '—',
        default: '<code>fade</code>'
    }, {
        name: '<code>inline</code>',
        description: 'Dropdown content (items) are shown inline, trigger is removed',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>mobile-modal</code>',
        description: 'Dropdown content (items) are shown into a modal on mobile',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>aria-role</code>',
        description: 'Role attribute to be passed to list container for better accessibility. Use <code>menu</code> only in situations where your dropdown is related to navigation menus.',
        type: 'String',
        values: '<code>list</code>, <code>menu</code>',
        default: '—'
    }, {
        name: '<code>multiple</code>',
        description: 'Allows multiple selections',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>trap-focus</code>',
        description: 'Trap focus inside the dropdown.',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>can-close</code>',
        description: 'Can close dropdown by pressing escape or by clicking outside',
        type: 'Boolean, Array',
        values: '<code>escape</code>, <code>outside</code>',
        default: '<code>true</code>'
    }, {
        name: '<code>close-on-click</code>',
        description: 'Close dropdown when content is clicked',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }],
    slots: [{
        name: 'default',
        description: '',
        props: ''
    }, {
        name: '<code>trigger</code>',
        description: 'Trigger content for the dropdown',
        props: '—'
    }],
    events: [{
        name: '<code>change</code>',
        description: 'Triggers when an item is selected',
        parameters: '<code>value: String</code>'
    }, {
        name: '<code>active-change</code>',
        description: 'Triggers when dropdown is activated or deactivated (visibility of list)',
        parameters: '<code>active: Boolean</code>'
    }],
    methods: [{
        name: '<code>toggle</code>',
        description: 'Toggle activation (dropdown list visibility)'
    }]
}, {
    title: 'Item',
    props: [{
        name: '<code>value</code>',
        description: 'The value that will be returned on events and v-model',
        type: 'Any',
        values: '—',
        default: '<code>null</code>'
    }, {
        name: '<code>separator</code>',
        description: 'Set the item to be a separator',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>disabled</code>',
        description: 'Item is disabled',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>focusable</code>',
        description: 'Item can be focused',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>custom</code>',
        description: 'Item is not a clickable item',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>has-link</code>',
        description: 'Use it if your item is an anchor tag or <code>router-link</code>',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>paddingless</code>',
        description: 'Remove padding',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>aria-role</code>',
        description: 'Role attribute to be passed to list item for better accessibility. Use <code>menuitem</code> only in situations where your dropdown is related to navigation menus.',
        type: 'String',
        values: '<code>listitem</code>, <code>menuitem</code>',
        default: '—'
    }],
    slots: [{
        name: 'default',
        description: '',
        props: ''
    }],
    events: [{
        name: '<code>click</code>',
        description: 'Triggers when the item is clicked',
        parameters: '—'
    }]
}]);

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    name: '<code>$dropdown-mobile-breakpoint</code>',
    description: 'The dropdown will be displayed as a modal below this value.',
    default: '<code>$desktop</code>'
}, {
    name: '<code>$dropdown-background-color</code>',
    description: 'Modal background color when the dropdown is shown as a modal.',
    default: '<code>rgba($black, 0.86)</code>'
}, {
    name: '<code>$dropdown-disabled-opacity:</code>',
    description: 'Defines dropdown disabled opacity.',
    default: '<code>0.5</code>'
}]);

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1065),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19806782",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1066),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1067),
  /* template */
  __webpack_require__(1068),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1069),
  /* template */
  __webpack_require__(1070),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1071),
  /* template */
  __webpack_require__(1072),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1384),
  /* template */
  __webpack_require__(1390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/11.6e7578c928cc28bf6224.js